import { Component, EventEmitter, OnInit, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DateObject, Document_Upload_File, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from 'src/app/models/common';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { IstDataShareService } from 'src/app/services/ist/ist-datashare.service';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { UserService } from 'src/app/services/user.service';
import * as $ from 'jquery';
import { serviceConstants } from 'src/app/constants/service.constants';
import * as _ from 'lodash';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileService } from 'src/app/services/file.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-ist-activities-seminars-speakers',
  templateUrl: './ist-activities-seminars-speakers.component.html',
  styleUrls: ['./ist-activities-seminars-speakers.component.scss']
})
export class IstActivitiesSeminarsSpeakersComponent implements OnInit {

  @Input() public Content: any;
  ActivitySessions: UntypedFormGroup;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  files: any[];
  SeminosList: any = [];
  ApplicationID: any;
  Allfiles = [];
  userType: string = "";
  FilesList = [];
  ScreenFilesList = [];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  document_attach_list: Document_Upload_File[] = [];
  loadGrid = false;
  filesCopy: any;
  staticformFields: any;
  permission: string = "";
  IsFormToched: boolean = false;
  tooltipValue: any;
  Application_Type_ID: string = "";
  isDateModified: boolean = false;
  Full_Date: DateObject;
  submittedresponse: SCREEN_RESPONSE[] = [];
  ModelData: any = null;
  SCREEN_MODEL: any = null;
  title: string = "";
  Status: any;
  SubTypeValues: any;
  SpeakersList: any[] = [];
  screenName: string = '';
  genInfoFieldControls: any;
Currency_ID: string="";

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private appFunctions: AppFunctionsService,
    private datashareService: IstDataShareService,
    private userService: UserService,
    public commonService: CommonService,
    public fileService: FileService,
    public datepipe: DatePipe
  ) {
    this.files = [];
    this.Allfiles = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.userType = this.userService.getUserType();
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
        this.datashareService.Application_Type_ID.subscribe(x => {
          this.Application_Type_ID = x;
        });
      }  
 if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.datashareService.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.getStaticFiledsData('SCR-010');
    this.GetScreenConfigControls('SCR-010');  

    if (this.Content.heading == 'View') {
      this.permission = "view";
    }

    if(this.Content.content.rowData != null){
    this.BindDataToStaticControls(this.Content.content.rowData);
    }

    this.getRecordFprEdit();
  }

  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }  

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID,'', (ScreenData) => {
      this.staticformFields = ScreenData["SCREEN_CONTROL"];
      this.screenName = ScreenData.NAME;      
      this.getRecordFprEdit();
    });
  }

  save() {
    if (this.validateControls()) {      

      var data = new Object();
      data["ID"] = this.Content.content.id;
      data["TITLE"] = this.staticformFields?.filter(x => x.FIELD_CODE == "AS_TITLE")[0].ControlValue;
      data["FIST_NAME"] = this.staticformFields?.filter(x => x.FIELD_CODE == "FIST_NAME")[0].ControlValue;
      data["LAST_NAME"] = this.staticformFields?.filter(x => x.FIELD_CODE == "LAST_NAME")[0].ControlValue;
      data["QUALIFICATION"] = this.staticformFields?.filter(x => x.FIELD_CODE == "QUALIFICATION")[0].ControlValue;
      data["OCCUPATION"] =  this.staticformFields?.filter(x => x.FIELD_CODE == "OCCUPATION")[0].ControlValue;
        this.FilesList?.forEach((item) => {
          this.document_attach_list.push(item);
        });
      data['FILES'] = this.document_attach_list;
      let SpkName = data['FIST_NAME'] + " " + (data['LAST_NAME'] == null ? '' : data['LAST_NAME']);
      if (this.Content.heading == 'Add') {
        data['ID'] = this.commonService.getUniqueId();
      }
      this.modalRef.close(data);
      


    } else {

      if (this.Content.content.rowData['TITLE'] == this.staticformFields?.filter(x => x.FIELD_CODE == "AS_TITLE")[0].ControlValue
        && this.Content.content.rowData['FIST_NAME'] == this.staticformFields?.filter(x => x.FIELD_CODE == "FIST_NAME")[0].ControlValue
        && this.Content.content.rowData['LAST_NAME'] == this.staticformFields?.filter(x => x.FIELD_CODE == "LAST_NAME")[0].ControlValue
        && this.Content.content.rowData['QUALIFICATION'] == this.staticformFields?.filter(x => x.FIELD_CODE == "OCCUPATION")[0].ControlValue
        && this.Content.content.rowData['OCCUPATION'] == this.staticformFields?.filter(x => x.FIELD_CODE == "QUALIFICATION")[0].ControlValue
        && _.isEqual(this.Content.content.rowData['FILES'], this.FilesList) && this.FilesList.length == 0
      ) {
        this.modalRef.dismiss();
      } else {
        this.modalRef.close('yes');
      }
    }

  }

  SessionvalidateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.ActivitySessions.value;

    if (this.staticformFields?.AS_TITLE.IS_MANDATORY && this.staticformFields?.AS_TITLE.IS_Display) {
      if (formData.TITLE === null || formData.TITLE === "" || formData.TITLE === undefined) {
        $("#TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#TITLE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.AS_TITLE.LABEL_NAME} <br/>`;
      } else if (formData.TITLE != null && formData.TITLE != undefined && formData.TITLE.trim() == "") {
        $("#TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#TITLE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.AS_TITLE.LABEL_NAME} <br/>`;
      }
      else {
        $("#TITLE").addClass("ng-untouched ng-valid");
        $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.FIST_NAME.IS_MANDATORY && this.staticformFields?.FIST_NAME.IS_Display) {
      if (formData.FIST_NAME === null || formData.FIST_NAME === "" || formData.FIST_NAME === undefined) {
        $("#FIST_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#FIST_NAME").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.FIST_NAME.LABEL_NAME} <br/>`;
        isValid = false;
      } else if (formData.FIST_NAME != null && formData.FIST_NAME != undefined && formData.FIST_NAME.trim() == "") {
        $("#FIST_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#FIST_NAME").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.FIST_NAME.LABEL_NAME} <br/>`;
        isValid = false;
      }
      else {
        $("#FIST_NAME").addClass("ng-untouched ng-valid");
        $("#FIST_NAME").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.LAST_NAME.IS_MANDATORY && this.staticformFields?.LAST_NAME.IS_Display) {
      if (formData.LAST_NAME === null || formData.LAST_NAME === "") {
        $("#LAST_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#LAST_NAME").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.LAST_NAME.LABEL_NAME} <br/>`;
        isValid = false;
      } else if (formData.LAST_NAME != null && formData.LAST_NAME != undefined && formData.LAST_NAME.trim() == "") {
        $("#LAST_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#LAST_NAME").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.LAST_NAME.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#LAST_NAME").addClass("ng-untouched ng-valid");
        $("#LAST_NAME").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.OCCUPATION.IS_MANDATORY && this.staticformFields?.OCCUPATION.IS_Display) {
      if (formData.OCCUPATION === null || formData.OCCUPATION === "" || formData.OCCUPATION === undefined) {
        $("#OCCUPATION").addClass("ng-touched ng-invalid validate-error");
        $("#OCCUPATION").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.OCCUPATION.LABEL_NAME} <br/>`;
        isValid = false;
      } else if (formData.OCCUPATION != null && formData.OCCUPATION != undefined && formData.OCCUPATION.trim() == "") {
        $("#OCCUPATION").addClass("ng-touched ng-invalid validate-error");
        $("#OCCUPATION").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.OCCUPATION.LABEL_NAME} <br/>`;
        isValid = false;
      }
      else {
        $("#OCCUPATION").addClass("ng-untouched ng-valid");
        $("#OCCUPATION").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.QUALIFICATION.IS_MANDATORY && this.staticformFields?.QUALIFICATION.IS_Display) {
      if (formData.QUALIFICATION === null || formData.QUALIFICATION === "" || formData.QUALIFICATION === undefined) {
        $("#QUALIFICATION").addClass("ng-touched ng-invalid validate-error");
        $("#QUALIFICATION").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.QUALIFICATION.LABEL_NAME} <br/>`;
        isValid = false;
      } else if (formData.QUALIFICATION != null && formData.QUALIFICATION != undefined && formData.QUALIFICATION.trim() == "") {
        $("#QUALIFICATION").addClass("ng-touched ng-invalid validate-error");
        $("#QUALIFICATION").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.QUALIFICATION.LABEL_NAME} <br/>`;
        isValid = false;
      }
      else {
        $("#QUALIFICATION").addClass("ng-untouched ng-valid");
        $("#QUALIFICATION").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.Activities_CF.IS_MANDATORY && this.staticformFields?.Activities_CF.IS_Display) {
      if (this.FilesList != undefined && this.FilesList.length > 0) {
        this.FilesList.forEach((item) => {
          this.document_attach_list.push(item);
        });
      }
      if (this.document_attach_list == null || this.document_attach_list.length == 0) {
        isValid = false;
        message += `Please upload ${this.staticformFields?.Activities_CF.LABEL_NAME} <br/>`;
      }
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: message } } });
    return isValid;
  }

  getRecordFprEdit() {
    this.summaryService.getScreenDataForEdit("api/ISTActivitiesseminars/Edit?RecordID=" + this.Content.content.id).subscribe(result => {
      var count = 0;
      if (result["ChildList"] != null) {
        result["ChildList"].forEach(x => {
          count = count + 1;
          if (count == parseInt("1")) {
            this.GetSessionDetails(x);
          }
        });
      }

      if(this.Content.content.rowData != null){
        this.BindDataToStaticControls(this.Content.content.rowData);
        } else{
          this.BindDataToStaticControls(result);
        } 
    });
  }

  GetSessionDetails(data) {
    this.files = []; 
    this.BindDataToDynamicControls();
    this.BindDataToStaticControls(data);   
  }

  DeleteSavedUpload(item): void {
    this.commonService.CheckIsFileIsRefereancedInReviw(item).subscribe((x) => {
      if (x["Status"] == 2 && x["Data"] == false) {
        this.commonService.ValidationBanner(x["Message"]);
      }
      else {
        let index = this.FilesList.findIndex(x => x.ID == item);
        if (index != -1) {
          this.FilesList[index].Status = "Delete";
        }
        this.ActivitySessions.markAsDirty();
      }
    })


  }
  close() {
    this.modalRef.dismiss('Yes');
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }


  validateControls(): boolean {
    let isValid = true;
    let message = "";
    this.staticformFields.forEach((item) => {
      if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
        switch (item.CONTROL) {
          case 1:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 2:
          case 3:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 5:
          case 4:
          case 11:
          case 10:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 6:
            let seletedItem = "";
            for (let c = 0; c < item.SourceItems.length; c++) {
              if (item.SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = item.SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + item.SourceItems[c].value;
              }
            }
            item.ControlValue = seletedItem;
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 7:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 8:
            if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0 && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 9:
            break;
        }
      }
    });

    //Check atleast single field value exists
    if (isValid) {
      isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
      if (!isValid) {
        message += `Please enter atleast one field. <br/>`;
      }
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }

  BindDataToDynamicControls() {
    if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "SCR-010";
      sr.RowId = this.Content.content.id;
      sr.AppId = this.ApplicationID;
      this.summaryService.getISTScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          for (var i = 0; i < this.staticformFields.length; i++) {
            var response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

            if (response != null && response.length > 0) {
              if (this.staticformFields[i].CONTROL == '6') {
                this.staticformFields[i].Display_Field = true;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  var options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                    for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                      if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                        this.staticformFields[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.staticformFields[i].SourceItems[c].Checked = false;
                      }
                    }
                  }

                }
              }
              else if (this.staticformFields[i].CONTROL == '10') {
                this.staticformFields[i].Display_Field = true;
                this.staticformFields[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = [];

                  var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.staticformFields[i].ControlValue.push(item);
                  });
                  this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.staticformFields[i].ControlValue = [];
                }
              }
              else if (this.staticformFields[i].CONTROL == '5') {
                this.staticformFields[i].Display_Field = true;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;

                  if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    // let formd = this.datepipe.transform(new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER), 'dd-MMM-yyyy');
                    let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
                  }

                }

              }
              else {
                this.staticformFields[i].Display_Field = true;
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.staticformFields[i].UploadFiles = response[0].UploadFiles;
              if (this.staticformFields[i].CONTROL == '4') {
                this.staticformFields[i].Display_Field = true;
                this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i]);
              }
            }

          }
        }

      });
    }
  }

  BindDataToStaticControls(MainObjData: any) {
    let today = new Date(); today.setHours(0, 0, 0, 0);

    for (var i = 0; i < this.staticformFields?.length; i++) {
      switch (this.staticformFields[i].FIELD_CODE) {
        case "AS_TITLE":
          this.staticformFields[i].Display_Field = true;
          this.staticformFields[i].ControlValue = MainObjData?.TITLE;
          this.title = MainObjData?.TITLE;
          break;
        case "FIST_NAME":
          this.staticformFields[i].Display_Field = true;
          this.staticformFields[i].ControlValue = MainObjData?.FIST_NAME;
          break;
        case "LAST_NAME":
          this.staticformFields[i].Display_Field = true;
          this.staticformFields[i].ControlValue = MainObjData?.LAST_NAME;
          break;
        case "OCCUPATION":
          this.staticformFields[i].Display_Field = true;
          this.staticformFields[i].ControlValue = MainObjData?.OCCUPATION;
          break;
        case "QUALIFICATION":
          this.staticformFields[i].Display_Field = true;
          this.staticformFields[i].ControlValue = MainObjData?.QUALIFICATION;
          break;
        case "Activities_CF":
          this.staticformFields[i].Display_Field = true;
          if(this.Content.heading != "Add"){
          this.staticformFields[i].UploadFiles = MainObjData?.FILES;
          }
          this.FilesList = this.staticformFields[i].UploadFiles;
          break;

      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i]);
      }
    }

  }

  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });
    }
  }

  OpenFile(item: Document_Upload_File): void {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);  
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  uploadchange(event, ques: SCREEN_CONTROL): void {
   // let Flag = true;

   let Isexe = false;
let Is5oMB = false;


    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && (ext == 'exe')) {
        Isexe = true;        
      }
      else if (file != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          } else {
            ques.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            })
            ques.UploadFiles.push(uploadFile);
          }
        });

      }
    }
    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else {

    }
  }

  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }

  singleonChange($event, question) {
    this.IsFormToched = true;

    if (question.FIELD_CODE == 'TYPE') {
      this.staticformFields.find(x => x.FIELD_CODE == 'SUB_TYPE').ControlValue = null;
      this.staticformFields.find(x => x.FIELD_CODE == 'SUB_TYPE').SourceItems = this.SubTypeValues?.filter(x => x.Parentvalue == $event.value);
    }
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question);
  }

  ApplyConditions($event, question) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];


    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })


    //default
    if (value != "") {
      this.staticformFields.forEach((con) => {
        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
      });
    }

  }

  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })

    this.staticformFields.forEach((con) => {
      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
      }
    });

  }

  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }

  GetIstGenInfoScreenConfigControls() {
    this.commonService.GetScreenConfigControls('SCR-001', '', '', (ScreenData) => {
      this.genInfoFieldControls = ScreenData["SCREEN_CONTROL"];
    });
  }

  SaveIST_GI_APP() {
    let uploadData = new FormData();
    uploadData.append("ScreenControlsData", JSON.stringify(this.genInfoFieldControls));
    uploadData.append("Appid", '');
    uploadData.append("Application_Type_ID", this.Application_Type_ID);
    uploadData.append("Currency_ID", this.Currency_ID);

    return this.summaryService.SaveIstGeneralInfo("api/ISTGeneralInfo/Insert", uploadData);
  }

  isAllowedExtensionFile(Filename) {
    return this.commonService.isAllowedExtension(Filename);
  }
}
